<template>
  <v-card flat class="mx-2 mb-10">
    <v-text-field
      dense
      v-model="search"
      append-icon="mdi-magnify"
      :label="$t('components.analytics.AnalyticsDataTableDialog.search')"
      single-line
      hide-details
      solo
      max-with="200"
    ></v-text-field>
    <v-data-iterator :search="search" :items="myChargingStation" :items-per-page="5">
      <template v-slot:default="props">
        <v-row>
          <v-col cols="12" md="6" v-for="(myThg, i) in props.items" :key="i">
            <thg-charging-station-card :selection="myThg" :meterReadings="meterReadingsByChargingStation(myThg)" />
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
  </v-card>
</template>

<script lang="ts">
import ThgChargingStationCard from "@/components/thg/ThgChargingStationCard.vue";
import { PartnerColor } from "@/lib/partnerColor";
import { ThgChargingStationViewModelGen, ThgThgMeterReadingViewModelGen } from "@/services/thg/v1/data-contracts";
import { ChargingStationModule } from "@/store/modules/charging-station.store";
import { MeterReadingModule } from "@/store/modules/meter-reading.store";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    ThgChargingStationCard
  }
})
export default class ThgChargingStationCardIterator extends Vue {
  search = "";
  partnerColor = new PartnerColor();

  get myChargingStation() {
    return ChargingStationModule.charingStations;
  }

  meterReadingsByChargingStation(chargingStation: ThgChargingStationViewModelGen): ThgThgMeterReadingViewModelGen[] {
    const mr = MeterReadingModule.meterReadingsPerChargingStationLookup.get(chargingStation.id);
    if (!mr) {
      return [];
    }
    return mr;
  }
}
</script>

<style>
.form {
  margin-top: 20px;
}
</style>
